<template>
  <div class="container">
    <Modal v-model="modalOpened" width="400" :mask-closable="uploadStatus !== 'uploading'">
      <p slot="header">
        <Icon type="ios-cloud-upload-outline" />
        <span style="margin-left: 8px">导入金蝶物料</span>
      </p>
      <TimelineItem v-if="uploadStatus">
        <p class="time">4. 上传进度</p>

        <Alert :type="alertStatus" style="margin-top: 12px">
          {{
          uploadText
          }}
        </Alert>
        <Progress :percent="completeProgress" :status="progressBarStatus" />
      </TimelineItem>

      <div slot="footer">
        <Button
          :disabled="uploadStatus === 'uploading'"
          :loading="uploadStatus === 'uploading'"
          @click="modalOpened = false"
        >取消</Button>
      </div>
    </Modal>
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchSales"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        ></Input>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="15"
          @on-change="loadSales"
          show-total
          simple
          style="margin-right: 24px"
        />
        <input
          type="file"
          name="file"
          id="file"
          class="inputfile"
          @change="importJinDieTable($event)"
          ref="inputFile"
        />
        <label class="custom-file-upload" for="file">导入金蝶物料</label>
        <Button
          v-if="
            currentUser.superAdmin ||
            arrayIntersection(['salesAssist'], currentUser.simpleRole).length >
              0
          "
          type="primary"
          @click="openCreateSalesDrawer()"
        >新增销售项目</Button>
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table :columns="columns" :data="tableData" :height="tableHeight">
        <template
          slot-scope="{ row }"
          slot="action"
          v-if="
            currentUser.superAdmin ||
            arrayIntersection(
              [
                'factoryLeader',
                'technologyLead',
                'technology',
                'allFactoryLeader',
              ],
              currentUser.simpleRole
            ).length > 0
          "
        >
          <Button
            type="info"
            ghost
            size="small"
            icon="ios-funnel"
            @click="$refs.ReplaceSalesDrawer.openDrawer(row)"
          >更换销售项目</Button>
        </template>
        <template slot-scope="{ row }" slot="verify">
          <div v-if="!row.itemCodeConfirmed">
            <Button type="info" ghost size="small" @click="verifyJDItemCode(row)">确认无误</Button>
          </div>
          <div v-else>已确认</div>
        </template>
      </Table>
    </div>
    <ReplaceSalesDrawer ref="ReplaceSalesDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import dayjs from "dayjs";
import ReplaceSalesDrawer from "./ReplaceSalesDrawer";
import axios from "axios";
import { baseURL } from "@/utils/axios";
import _ from "lodash";

export default {
  name: "JDItemCodeCheck",
  components: { ReplaceSalesDrawer },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      digit: 0,
      showSupplying: "正在供货",
      tableData: [],
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            )
        },
        {
          title: "项目代称",
          key: "abbr",
          render: (h, params) => {
            if (
              this.currentUser.superAdmin ||
              arrayIntersection(["salesAssist"], this.currentUser.simpleRole)
                .length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      cursor: "pointer",
                      color: "#42b983"
                    },
                    on: {
                      click: () => {
                        this.$refs.CreateSalesDrawer.openDrawer(params.row);
                      }
                    }
                  },
                  params.row?.abbr ?? params.row.customer.name +
                        " — " +
                        params.row.material.model
                )
              ]);
            } else {
              return h(
                "h4",
                params.row?.abbr ?? params.row.customer.name +
                        " — " +
                        params.row.material.model
              );
            }
          }
        },
        {
          title: "客户",
          key: "customer",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small"
                  }
                },
                params.row.customer.name
              )
            ]);
          }
        },
        {
          title: "产品",
          key: "material",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              `${params.row.material.model} ${params.row.material.name}`
            )
        },
        {
          title: "公司",
          key: "company",
          align: "left",
          render: (h, params) => {
            return h("span", [
              h(
                "h4",
                params.row.company?.abbr ?? params.row.company?.name
              )
            ]);
          }
        },
        {
          title: "发货工厂",
          key: "factory",
          align: "left",
          render: (h, params) =>
            h("span", `${params.row.factory ? params.row.factory.name : ""}`)
        },
        {
          title: "金蝶名称",
          key: "company",
          align: "left",
          render: (h, params) => {
            return h("span", [h("h4", params.row.JDName)]);
          }
        },
        {
          title: "物料编码",
          key: "company",
          align: "left",
          render: (h, params) => {
            return h("span", [h("h4", params.row.JDItemCode)]);
          }
        },
        {
          title: "物料编码操作",
          align: "center",
          key: "action",
          slot: "action"
        },
        {
          title: "物料编码确认",
          align: "center",
          key: "verify",
          slot: "verify"
        },
        {
          title: "归档",
          key: "company",
          align: "left",
          render: (h, params) => {
            return h("span", [
              h("h4", params.row.archived ? "已归档" : "未归档")
            ]);
          }
        },
        {
          title: "送货中",
          key: "company",
          align: "left",
          render: (h, params) => {
            return h("span", [
              h("h4", params.row.isSupplying ? "送货中" : "待送货")
            ]);
          }
        }
      ],
      tableHeight: 300,
      modalOpened: false,
      importCusfile: undefined,
      uploadStatus: undefined, // enum: [undefined, 'uploading', 'success', 'error']
      uploadText: "未上传",
      completeProgress: 0,
      progressBarStatus: undefined
    };
  },
  computed: mapState({
    totalRows: state => state.sales.totalCounts,
    currentUser: state => state.auth.currentUser,
    alertStatus: function() {
      switch (this.uploadStatus) {
        case "uploading":
          return "info";
        case "success":
          return "success";
        case "error":
          return "error";
        default:
          return "info";
      }
    }
  }),
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getSales: "sales/getSalesAction",
      updateSales: "sales/updateSalesAction"
    }),
    async loadSales(page) {
      if (page) this.page = page - 1;
      let api = {
        skip: this.page * 15,
        limit: 15
      };
      if (this.searchText) api.cus_name = this.searchText;
      try {
        this.tableLoading = true;
        const data = await this.getSales({
          ...api,
          itemCodeConfirmed: false
        });
        this.tableData = data.salesList;
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchSales: _.debounce(function() {
      this.page = 0;
      this.loadSales();
    }, 1000),
    openCreateSalesDrawer() {
      this.$refs.CreateSalesDrawer.openDrawer();
    },
    // 上传金蝶云资料
    importJinDieTable(e) {
      Object.assign(this.$data, this.$options.data());
      this.modalOpened = true;
      this.uploadStatus = "uploading";
      this.uploadText = "上传中...";
      this.progressBarStatus = null;

      //获取选定的文件
      this.importCusfile = e.target.files[0];

      let param = new FormData();
      param.append("file", this.importCusfile);

      if (!this.checkFileType(this.importCusfile.name.split(".")[1])) {
        this.uploadStatus = "error";
        return (this.uploadText = "只支持.xls .xlsx格式");
      }

      var that = this;
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: e => {
          that.completeProgress = ((e.loaded / e.total) * 100) | 0;
        }
      };

      axios.interceptors.request.use(
        function(config) {
          // Do something before request is sent
          let token = localStorage.getItem("token");
          // ;
          config.headers["token"] = token;
          return config;
        },
        function(error) {
          // Do something with request error
          return Promise.reject(error.response.data);
        }
      );

      axios
        .post(`${baseURL}/import_item_code_table`, param, config)
        .then(function(response) {
          that.uploadStatus = "success";
          that.uploadText = "导入成功";
          that.$refs.inputFile.value = null;
          that.$emit("uploadSuccess");
          const data = response.data.data;
          that.$Message.info(
            `成功创建${data.create}个，失败${data.error.length}个，重复${data.existed}个，更新${data.update}个`
          );
          that.modalOpened = false;
        })
        .catch(function(error) {
          that.uploadStatus = "error";
          that.uploadText = `上传错误：${error.message}`;
          that.progressBarStatus = "wrong";
          that.$refs.inputFile.value = null;
        });
    },
    checkFileType: function(fileType) {
      return ["xls", "xlsx"].includes(fileType);
    },

    // 金蝶云确认无误
    async verifyJDItemCode(sales) {
      try {
        await this.updateSales({
          id: sales._id,
          data: {
            itemCodeConfirmed: true
          }
        });
        this.$Message.success("确认成功");
      } catch (error) {
        this.$Message.error(error + "确认失败");
      }
    }
  },
  created() {
    this.loadSales();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  }
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)

.button-group
  display flex

.container
  overflow-y auto

.item
  display flex
  justify-content space-between

.inputfile
  // display: none;
  width 0.1px
  height 0.1px
  opacity 0
  overflow hidden
  position absolute
  z-index -1

.custom-file-upload
  border 1px solid rgb(220, 222, 226)
  display inline-block
  padding 6px 12px
  margin-right 12px
  cursor pointer
  font-size 12px
  border-radius 4px
  user-select none
  touch-action manipulation
  color #515a6e
  transition color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear, -webkit-box-shadow 0.2s linear

.inputfile + label:hover
  color #0c89f0
  border-color #0c89f0
</style>
